module.exports = __webpack_public_path__ + "611d188a5154b677bcba23ff77c81fc6.png";